import { format } from "date-fns";

function useAgGrid() {
    const dateFormatter = (params) =>
        params.value ? format(new Date(params.value), "MMM d, yyyy") : "";
    return { dateFormatter };
}

export default useAgGrid;
